import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const PrivacyPage = () => (
  <>
    <Header />
    <main className="main page-content">
      <h1 className="page-title">Privacy Policy</h1>
      <div className="legal-content">
        <p>Framecast News respects your privacy. We collect minimal data necessary to provide our service.</p>
        <h2>What We Collect</h2>
        <ul>
          <li>Email address (if you sign up for updates)</li>
          <li>Anonymous usage analytics</li>
        </ul>
        <h2>What We Don't Do</h2>
        <ul>
          <li>Sell your data to third parties</li>
          <li>Track your reading habits for personalization</li>
          <li>Use cookies for advertising</li>
        </ul>
        <p>Questions? Contact us at privacy@framecast.news</p>
      </div>
    </main>
    <Footer />
  </>
);

export default PrivacyPage;
